import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {useDropzone} from 'react-dropzone';
import { connect } from 'react-redux';
import { ajaxUploadFile } from '../redux/FeedbackRedux';
import Alert from "../Alert";

function Dropzone(props) {

const baseStyle = {
flex: 1,
display: 'flex',
flexDirection: 'column',
alignItems: 'center',
padding: '20px',
borderWidth: 2,
borderRadius: 2,
borderColor: '#eeeeee',
borderStyle: 'dashed',
backgroundColor: '#fafafa',
color: '#bdbdbd',
outline: 'none',
transition: 'border .24s ease-in-out',
fontSize: '12px'
};

const activeStyle = {
borderColor: '#2196f3'
};

const acceptStyle = {
borderColor: '#00e676'
};

const rejectStyle = {
borderColor: '#ff1744'
};

const thumbsContainer = {
display: 'flex',
flexDirection: 'row',
flexWrap: 'wrap',
marginTop: 16
};

const thumb = {
display: 'inline-flex',
borderRadius: 2,
border: '1px solid #eaeaea',
marginBottom: 8,
marginRight: 8,
width: 100,
height: 100,
padding: 4,
boxSizing: 'border-box'
};

const thumbInner = {
display: 'flex',
minWidth: 0,
overflow: 'hidden',
width: '100%',
};

const img = {
display: 'block',
width: '100%',
height: '100%',
objectFit: 'cover',
};

const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  var onDrop = function(acceptedFiles){
    var reader_files = [];
    acceptedFiles.forEach((file) => {
    props.dispatch(ajaxUploadFile(props.feedback_id, file));
    });
  }

const {getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject} = useDropzone({onDrop, multiple: true});
  return (
    <div id="find_dropzone" {...getRootProps({style})}>
        <Alert alert={props.state.alert.alert} location={'dropzone'}/>
      <input {...getInputProps()} />
      <p>{ __('Drag \'n\' drop some file here, or click to select files') }</p>
    </div>
  )
}


function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(Dropzone)
